/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiAdminLivekitSipDispatchRulesDispatchRuleIdDelete$Params {
  dispatchRuleId: string;
}

export function apiAdminLivekitSipDispatchRulesDispatchRuleIdDelete(http: HttpClient, rootUrl: string, params: ApiAdminLivekitSipDispatchRulesDispatchRuleIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAdminLivekitSipDispatchRulesDispatchRuleIdDelete.PATH, 'delete');
  if (params) {
    rb.path('dispatchRuleId', params.dispatchRuleId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiAdminLivekitSipDispatchRulesDispatchRuleIdDelete.PATH = '/api/Admin/livekit/sip/dispatch-rules/{dispatchRuleId}';
